<template>
<div class="no_file">
        <OtherHead v-if="!isMobile" :tipText="$t('暂无内容')"></OtherHead>
        <div class="empty_content">
            <img v-if="addLimit" src="@/assets/img/other/no_file.png" alt=""/>
            <img v-else src="@/assets/img/other/no_file_limit.png" alt=""/>
            <div class="empty_text">{{ emptyText }}</div>
        </div>
    </div>
</template>

<script lang="ts">
import { intl } from 'tci18n-vue3'
import { mapState } from 'vuex';
import OtherHead from './OtherHead.vue';
import { getBrowser } from '../../utils/browser';

export default {
  name: 'no_file',
  components: {
    OtherHead },

  data() {
    return {};
  },
  computed: {
    ...mapState({
      doc_id: (state) => state.kbModule.doc_id,
      doc_info: (state) => state.kbModule.doc_info,
      wikiSpaceInfo: (state) => state.kbModule.wikiSpaceInfo,
      spaceId: (state) => state.userModule.spaceId }),

    addLimit() {
      return this.wikiSpaceInfo?.space == this.spaceId;
    },
    isMobile() {
      return getBrowser().isMobile === true;
    },
    emptyText() {
      return intl.$t("暂无权限访问该知识库，请联系知识库管理员添加权限");
    } },

  methods: {} };
</script>

<style lang="scss" scoped>
.no_file {
    flex: 1;
    display: flex;
    flex-direction: column;

    .empty_content {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        img {
            width: 120px;
        }

        .empty_text {
            margin-top: 16px;
            height: 20px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #a2a4b0;
            text-align: center;
        }
    }
}
</style>
